import React, { useMemo } from 'react';

import { Flex, Text } from '@chakra-ui/react';
import { Controller, UseFormReturn } from 'react-hook-form';

import { Select } from 'components';
import { debouncePartner } from 'utils/debounces';

interface PartnerProps extends UseFormReturn{
  label?: string
  name?: string
 }

export default function Partner({
  control,
  watch,
  label = 'Parceiro',
  name = 'partner',
}: PartnerProps) {
  const partner = watch(name);

  const address = useMemo(() => {
    const line1 = '';
    const line2 = '';
    const current = partner?.address;
    if (current) {
      if (current.street) {
        line1.concat(`${current.street}, `);
      }
      if (current.number) {
        line1.concat(`${current.number} `);
      }
      if (current.complement) {
        line1.concat(`${current.complement} `);
      }
      if (current.district) {
        line1.concat(`- ${current.district}`);
      }

      // line2
      if (current.postalCode) {
        line2.concat(`${current.postalCode}, `);
      }
      if (current.city) {
        line2.concat(`${current.city} `);
      }
      if (current.state) {
        line2.concat(`- ${current.state}`);
      }
    }

    return {
      line1, line2,
    };
  }, [partner]);

  return (
    <Flex flexDir="column">
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Select
            label={label}
            loadOptions={debouncePartner}
            {...field}
          />
        )}
      />
      {!!partner?.address && (
        <>
          <Text
            mt={4}
            color="gray.500"
            variant="smallRegular">
            {address.line1}
          </Text>
          <Text
            color="gray.500"
            variant="smallRegular">
            {address.line2}
          </Text>
        </>
      )}
    </Flex>
  );
}
